import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Chip, Grid, Typography, withStyles } from '@material-ui/core';
import { EVENT_IMG } from '../constatns';
// import swal from '@sweetalert/with-react';

const styles = (theme) => ({
  container: {
    // position: 'absolute',
    bottom: 0,
    width: '100%',
  },
  sponsorDiv: {
    padding: theme.spacing(3, 0),
    backgroundColor: '#f8f8f8',
    color: '#666666',
    fontWeight: 'bold',
    fontSize: '1.4em',
  },
  footer: {
    // height: '80px',
    // backgroundColor: '#303439',
    backgroundColor: '#262626',
    color: '#eeeeee',
    '& p': {
      fontSize: '1em',
    },
    padding: theme.spacing(3, 0),
  },
  title: {
    fontWeight: 'bold',
  },
  logosDiv: {
    // display: 'flex',
    // padding: '32px 0',
    alignItems: 'center',
    // '& img:not(:last-child)': {
    //   marginRight: '1em',
    // },
  },
  logo: {
    // width: '100%',
    // maxWidth: '300px',
    maxHeight: '60px',
  },
  contact: {
    padding: theme.spacing(1, 0),
  },
  chips: {
    // color: 'white',
    // minWidth: '100px',
    // height: '25px',
    // '& span': {
    //   padding: 5,
    //   fontSize: '1.2em',
    // },
    color: '#fff',
    minWidth: '135px',
    padding: '19px 0',
    // height: '36px',
    '& span': {
      fontSize: 17,
      fontWeight: 700,
    },
  },
});

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      now: new Date(),
    };
  }

  componentDidMount() {}

  render() {
    const { classes } = this.props;
    const GRID_SIZE = 11;

    return (
      <div className={classes.container}>
        <div className={classes.sponsorDiv}>
          <Grid
            item
            container
            alignItems="center"
            xs={GRID_SIZE}
            spacing={1}
            style={{
              margin: '0 auto',
              paddingBottom: this.props.theme.spacing(1.5),
              borderBottom: '1px solid rgba(38, 38, 38, 0.05)',
              height: '100%',
            }}
          >
            <Grid container item xs={5}>
              <div style={{ display: 'flex', alignItems: 'center', marginRight: 32 }}>Hosted by</div>
              <div
                style={{ display: 'flex', alignItems: 'center' }}
                // className={classes.logosDiv}
              >
                <img src={`${EVENT_IMG}/prs2021_logo@2x.png`} alt="" className={classes.logo} style={{ width: 'auto', height: '35px' }} />
                <img
                  src="/images/PRS2022/ic/logo_kcpca_new.png"
                  alt=""
                  className={classes.logo}
                  style={{ width: 'auto', height: '60px', margin: 'auto 32px' }}
                />
              </div>
            </Grid>
            {/* <div>
              <img
                src={`${EVENT_IMG}/ic/icon_facebook.png`}
                style={{ cursor: 'pointer', padding: '0 16px 0 32px' }}
                onClick={() => {
                  window.open('https://www.facebook.com/KSPRS1966/');
                }}
                alt=""
              />

              <img
                src={`${EVENT_IMG}/ic/icon_instagram.png`}
                style={{ cursor: 'pointer', padding: '0 16px' }}
                onClick={() => {
                  window.open('https://www.instagram.com/prskorea/ ');
                }}
                alt=""
              />

              <img
                src={`${EVENT_IMG}/ic/icon_youtube.png`}
                style={{ cursor: 'pointer', padding: '0 16px' }}
                onClick={() => {
                  window.open('https://www.youtube.com/channel/UCcFvUVXjr0P4GS-gSC2SWtQ');
                }}
                alt=""
              />
            </div> */}

            {/* 메인 스폰서 Grid */}
            <Grid container item xs={7}>
              <div style={{ display: 'flex', alignItems: 'center', marginRight: 32 }}>Supported by</div>
              {/* <Grid style={{ display: 'flex', alignItems: 'center' }}>Supported by</Grid> */}

              <div
                style={{ display: 'flex', alignItems: 'center' }}
                // className={classes.logosDiv}
              >
                <img src="/images/PRS2021/kto_logo.png" alt="" className={classes.logo} style={{ width: 'auto', height: '50px' }} />
                <img
                  src="/images/PRS2021/seoulLogo.png"
                  alt=""
                  className={classes.logo}
                  style={{ width: 'auto', height: '50x', margin: 'auto 32px' }}
                />
              </div>
            </Grid>
          </Grid>
          <Grid
            item
            container
            alignItems="center"
            xs={GRID_SIZE}
            spacing={1}
            style={{ margin: '0 auto', paddingBottom: this.props.theme.spacing(1.5), borderBottom: '1px solid rgba(38, 38, 38, 0.05)' }}
          >
            <Grid container alignItems="center" style={{ height: 350 }}>
              <Typography style={{ color: '#666666', fontWeight: 'bold', fontSize: '19.6px' }}>Sponsored by</Typography>
              <Grid style={{ paddingLeft: 32 }}>
                <Grid container alignItems="center" style={{ height: 70 }}>
                  <Chip style={{ backgroundColor: '#198ed8', margin: '0 16px 0 0' }} label="DIAMOND" className={classes.chips} />
                  <img
                    src={`${EVENT_IMG}/sponsor/dia_01.png`}
                    alt=""
                    onClick={() => {
                      window.open('http://www.lncbio.co.kr/');
                    }}
                    style={{ height: 60, width: 193, cursor: 'pointer' }}
                  />
                </Grid>
                <Grid container alignItems="center" style={{ height: 70 }}>
                  <Chip style={{ backgroundColor: '#38368b', margin: '0 16px 0 0' }} label="PLATINUM" className={classes.chips} />
                  <img
                    src={`${EVENT_IMG}/sponsor/platinum_01.png`}
                    alt=""
                    onClick={() => {
                      window.open('http://motivaimplants.co.kr/');
                    }}
                    style={{ height: 60, width: 193, cursor: 'pointer', marginRight: '8px' }}
                  />
                </Grid>
                <Grid container alignItems="center" style={{ height: 140 }}>
                  <Grid style={{ height: '100%' }}>
                    <Grid container alignItems="flex-start">
                      <Chip style={{ backgroundColor: '#b4b4b4', margin: '0 16px 0 0' }} label="SILVER" className={classes.chips} />
                    </Grid>
                  </Grid>
                  <Grid>
                    <Grid item xs={12} style={{ height: 70 }}>
                      <img
                        src={`${EVENT_IMG}/sponsor/silver_01.png`}
                        alt=""
                        // onClick={() => {
                        //   swal('', 'To be updated', 'info');
                        // }}
                        style={{ height: 60, width: 193, marginRight: '8px' }}
                      />

                      <img
                        src={`${EVENT_IMG}/sponsor/silver_02.png`}
                        alt=""
                        onClick={() => {
                          window.open('http://www.hansbiomed.com/');
                        }}
                        style={{ height: 60, width: 193, marginRight: '8px', cursor: 'pointer' }}
                      />

                      <img
                        src={`${EVENT_IMG}/sponsor/silver_03_b.png`}
                        alt=""
                        // onClick={() => {
                        //   swal('', 'To be updated', 'info');
                        // }}
                        style={{ height: 60, width: 193, marginRight: '8px', backgroundColor: '#fff' }}
                      />
                      <img
                        src={`${EVENT_IMG}/sponsor/silver_04.png`}
                        alt=""
                        onClick={() => {
                          window.open('https://www.trmkorea.com/');
                        }}
                        style={{ height: 60, width: 193, marginRight: '8px', cursor: 'pointer' }}
                      />
                    </Grid>
                    <Grid item xs={12} style={{ height: 70 }}>
                      <img
                        src={`${EVENT_IMG}/sponsor/silver_05.png`}
                        alt=""
                        onClick={() => {
                          window.open('http://planbio.co.kr/');
                        }}
                        style={{ height: 60, width: 193, marginRight: '8px', cursor: 'pointer' }}
                      />
                      <img
                        src={`${EVENT_IMG}/sponsor/silver_06.png`}
                        alt=""
                        onClick={() => {
                          window.open('https://www.jnjmedtech.com/ko-KR');
                        }}
                        style={{ height: 60, width: 193, marginRight: '8px', cursor: 'pointer' }}
                      />

                      <img
                        src={`${EVENT_IMG}/sponsor/silver_07.png`}
                        alt=""
                        onClick={() => {
                          window.open('https://www.cgbio.co.kr/');
                        }}
                        style={{ height: 60, width: 193, marginRight: '8px', cursor: 'pointer' }}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                <Grid container alignItems="center" style={{ height: 70 }}>
                  <Chip style={{ backgroundColor: '#79451B', margin: '0 16px 0 0' }} label="BRONZE" className={classes.chips} />
                  <img
                    src={`${EVENT_IMG}/sponsor/bronze_01.png`}
                    alt=""
                    onClick={() => {
                      window.open('http://www.allolife.com/default/');
                    }}
                    style={{ height: 60, width: 193, marginRight: '8px', cursor: 'pointer' }}
                  />
                  <img
                    src={`${EVENT_IMG}/sponsor/bronze_02.png`}
                    alt=""
                    onClick={() => {
                      window.open('https://osteonic.com/');
                    }}
                    style={{ height: 60, width: 193, marginRight: '8px', cursor: 'pointer' }}
                  />
                  <img
                    src={`${EVENT_IMG}/sponsor/bronze_03.png`}
                    alt=""
                    onClick={() => {
                      window.open('http://msbio.co.kr/');
                    }}
                    style={{ height: 60, width: 193, marginRight: '8px', cursor: 'pointer' }}
                  />

                  <img
                    src={`${EVENT_IMG}/sponsor/bronze_04.png`}
                    alt=""
                    onClick={() => {
                      window.open('https://www.ildong.com/kor/main/main.id');
                    }}
                    style={{ height: 60, width: 193, marginRight: '8px', cursor: 'pointer' }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
        <div className={classes.footer}>
          <Grid item container xs={GRID_SIZE} spacing={1} style={{ margin: '0 auto' }}>
            <Grid container alignItems="center" item xs={7}>
              <Grid>
                <img src={`${EVENT_IMG}/logo_footer_mono.png`} alt="" className={classes.logo} />
              </Grid>
              <Grid style={{ paddingLeft: 32 }}>
                <Typography className={classes.title}>Korean Society of Plastic and Reconstructive Surgeons</Typography>
                <div className={classes.contact}>
                  <Typography>101-2003 Lotte Castle President, 109 Mapo-daero, Mapo-gu, Seoul, 04146, Korea</Typography>
                  <Typography>Tel. +82-2-3472-4252 l Fax. +82-2-3472-4254 l E-mail: kprs@plasticsurgery.or.kr</Typography>
                </div>
              </Grid>
            </Grid>

            <Grid item xs={5}>
              <Typography className={classes.title}>PRS KOREA 2022 Secretariat</Typography>
              <Grid container className={classes.contact}>
                <Grid container item xs={11}>
                  <Grid item xs={2}>
                    <Typography>
                      <b style={{ color: '#5AD2FF' }}>General</b>
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography>
                      <b style={{ color: '#5AD2FF' }}>E. </b>
                      <a href={'mailto:secretariat.kprs@innon.co.kr'} style={{ color: '#f9f9f9' }}>
                        secretariat.kprs@innon.co.kr
                      </a>
                    </Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography>
                      <b style={{ color: '#5AD2FF' }}>T. </b>
                      +82-2-6411-7380
                    </Typography>
                  </Grid>
                </Grid>

                <Grid container item xs={11}>
                  <Grid item xs={2}>
                    <Typography>
                      <b style={{ color: '#5AD2FF' }}>Academic</b>
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography>
                      <b style={{ color: '#5AD2FF' }}>E. </b>
                      <a href={'mailto:academic.kprs@innon.co.kr'} style={{ color: '#f9f9f9' }}>
                        academic.kprs@innon.co.kr
                      </a>
                    </Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography>
                      <b style={{ color: '#5AD2FF' }}>T. </b>
                      +82-2-6411-7319, 7378
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          {/* <Grid item container xs={GRID_SIZE}  spacing={1} style={{ margin: '0 auto' }}>
            <Grid item xs={2} />
            <Grid item xs={10}>
              <Typography>Copyright© 2022 By Korean Society of Plastic and Reconstructive Surgeons All right Reserved.</Typography>
            </Grid>
          </Grid> */}
          <Grid item container xs={GRID_SIZE} justifyContent="center" spacing={1} style={{ margin: '0 auto' }}>
            <Typography>Copyright© 2022 By Korean Society of Plastic and Reconstructive Surgeons All right Reserved.</Typography>
          </Grid>
        </div>
      </div>
    );
  }
}
export default withRouter(withStyles(styles, { withTheme: true })(Footer));
